export default __webpack_public_path__ + "static/media/baseball-157928_640.91cff157.png";